let sexOptions = [
  {
    label: '男',
    value: 'M'
  },
  {
    label: '女',
    value: 'F'
  },
  {
    label: '保密',
    value: 'X'
  },
]

export default sexOptions



// WEBPACK FOOTER //
// ./src/utils/sexOptions.js